module.exports = __webpack_public_path__ + "static/media/Group 159.f8cd9f5f.svg";